import { Link } from 'react-router-dom';

interface CategoryCardProps {
  slug: string;
  name: string;
  icon: string;
  description: string;
  articleCount: number;
  color: string;
  imageUrl: string;
}

const colorMap: Record<string, { bg: string; text: string; border: string }> = {
  primary: {
    bg: 'bg-primary-50 group-hover:bg-primary-100/70',
    text: 'text-primary-500',
    border: 'border-primary-200/70 group-hover:border-primary-300',
  },
  accent: {
    bg: 'bg-accent-50 group-hover:bg-accent-100/70',
    text: 'text-accent-500',
    border: 'border-accent-200/70 group-hover:border-accent-300',
  },
  secondary: {
    bg: 'bg-secondary-50 group-hover:bg-secondary-100/70',
    text: 'text-secondary-500',
    border: 'border-secondary-200/70 group-hover:border-secondary-300',
  },
};

export default function CategoryCard({ slug, name, icon, description, articleCount, color, imageUrl }: CategoryCardProps) {
  const c = colorMap[color] || colorMap.primary;

  return (
    <Link
      to={`/category/${slug}`}
      className={`group block bg-background-50 rounded-lg border ${c.border} ${c.bg} transition-all duration-300 overflow-hidden cursor-pointer`}
    >
      <div className="relative w-full h-36 overflow-hidden">
        <img
          src={imageUrl}
          alt={name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          title={`撸撸社${name}分类`}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
      </div>
      <div className="p-4">
        <div className="flex items-center gap-2.5 mb-2">
          <div className={`w-9 h-9 flex items-center justify-center ${c.text}`}>
            <i className={`${icon} text-xl`}></i>
          </div>
          <h3 className="text-base font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors whitespace-nowrap">
            {name}
          </h3>
        </div>
        <p className="text-sm text-foreground-600 line-clamp-2 mb-3 leading-relaxed">
          {description}
        </p>
        <div className="flex items-center justify-between">
          <span className="text-xs text-foreground-500 whitespace-nowrap">
            <strong className="font-semibold text-foreground-800">{articleCount.toLocaleString()}</strong> 篇文章
          </span>
          <span className={`text-xs font-medium ${c.text} opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap`}>
            浏览分类 <i className="ri-arrow-right-line ml-0.5"></i>
          </span>
        </div>
      </div>
    </Link>
  );
}